import ObjectUtil from '../ObjectUtil'; // TODO remove and use ? operator

import {
  ADJUSTABLE_CATEGORIES_ARR,
  FEATURES_BY_CATEGORY_HASH,
  ADJUSTABLE_CATEGORIES,
  MASK_OPACITY,
} from '../../config/VTO';

const isAdjustableCategory = (category) => ADJUSTABLE_CATEGORIES_ARR.includes(category);

const isValidMode = (mode, availableModes) => Object.values(availableModes).includes(mode);

const isLipAdjustment = (category) => category === ADJUSTABLE_CATEGORIES.LIPCOLOR;

const getBox = (pointsArray) => {
  // added to prevent errors when array is empty
  if (!pointsArray.length) {
    return [0, 0, 0, 0];
  }

  let minx; let miny; let maxx; let
    maxy;
  minx = pointsArray[0].x;
  maxx = pointsArray[0].x;
  miny = pointsArray[0].y;
  maxy = pointsArray[0].y;
  for (let i = 1; i < pointsArray.length; i += 1) {
    minx = (minx < pointsArray[i].x) ? minx : pointsArray[i].x;
    miny = (miny < pointsArray[i].y) ? miny : pointsArray[i].y;
    maxx = (maxx > pointsArray[i].x) ? maxx : pointsArray[i].x;
    maxy = (maxy > pointsArray[i].y) ? maxy : pointsArray[i].y;
  }

  return [minx, miny, maxx, maxy];
};

const cloneCanvas = (oldCanvas) => {
  const newCanvas = document.createElement('canvas');
  const context = newCanvas.getContext('2d');

  newCanvas.width = oldCanvas.width;
  newCanvas.height = oldCanvas.height;

  context.drawImage(oldCanvas, 0, 0);

  return newCanvas;
};

const mixArrElements = (arr, fromIndex, toIndex) => arr.splice(fromIndex, 0, arr.splice(toIndex, 1)[0]);

const generateRGBAColor = ({
  r, g, b, a,
} = {}) => `rgba(${r}, ${g}, ${b}, ${a})`;

const generateFeaturesByCategory = (category) => FEATURES_BY_CATEGORY_HASH[category];

const generateLookObject = (product) => {
  const {
    upcs, selectedColorId, upcMap, category,
  } = product;

  const upcId = upcMap[selectedColorId] || upcMap[`${selectedColorId}_0`];
  const { modiFaceUPCInfo } = upcs[upcId];

  if (!modiFaceUPCInfo) {
    throw new Error('selected color is not supported for try on.');
  }

  const modiFaceUpcJSON = ObjectUtil.getChildProperty(modiFaceUPCInfo, 'modiFaceUpcJSON');

  return [{ category, ...modiFaceUpcJSON }];
};

const generateFeaturesCollection = (product, lookObject) => {
  const { color_r: r, color_g: g, color_b: b } = lookObject[0];
  const color = generateRGBAColor({
    r, g, b, a: MASK_OPACITY,
  });
  const featuresArr = generateFeaturesByCategory(product.category);

  return featuresArr.map((feature) => ({ color, feature }));
};

export {
  isAdjustableCategory,
  isValidMode,
  isLipAdjustment,
  getBox,
  cloneCanvas,
  mixArrElements,
  generateLookObject,
  generateFeaturesCollection,
};
